import type { ReactElement } from 'react';
import { useState } from 'react';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';

export function MarkdownEditor({
  value,
  onChange,
  rows = 6,
}: {
  value: string;
  onChange: (next: string) => void;
  rows?: number;
}): ReactElement {
  const [tab, setTab] = useState<'edit' | 'preview'>('edit');
  return (
    <div className="border border-slate-700 rounded">
      <div className="flex items-center gap-2 px-2 py-1 border-b border-slate-700 text-xs text-slate-400">
        <button
          type="button"
          className={tab === 'edit' ? 'text-accent' : 'hover:text-accent'}
          onClick={() => setTab('edit')}
        >
          Edit
        </button>
        <button
          type="button"
          className={
            tab === 'preview' ? 'text-accent' : 'hover:text-accent'
          }
          onClick={() => setTab('preview')}
        >
          Preview
        </button>
      </div>
      {tab === 'edit' ? (
        <textarea
          value={value}
          onChange={(event) => onChange(event.target.value)}
          rows={rows}
          className="w-full bg-transparent p-2 text-sm focus:outline-none"
        />
      ) : (
        <div className="p-3 prose prose-invert max-w-none text-sm">
          <ReactMarkdown remarkPlugins={[remarkGfm]}>
            {value || '*(empty)*'}
          </ReactMarkdown>
        </div>
      )}
    </div>
  );
}
